import { useSelector } from 'react-redux';

import { WithCompanyId, WithScope } from '@mews-commander/types';
import { ResponsiveTwoColumns } from '@mews-commander/ui';
import { Stack } from '@optimus-web/core';
import { hasReadOnlyPrivilegesForCompanyData } from '@mews-commander/legacy-entities/src/selectors/session/scope';
import Contracts from '../../../../contracts/components/Contracts';

type ContractTabProps = WithCompanyId & WithScope;

const ContractTab = ({ scope, companyId }: ContractTabProps) => {
    const readOnlyForm = useSelector(hasReadOnlyPrivilegesForCompanyData);

    return (
        <ResponsiveTwoColumns>
            <Stack vertical spacing="100">
                <Contracts
                    scope={`company-contracts-${scope}`}
                    // @ts-expect-error $TSFixMeError: Type '{ scope: string; ownerId: string; noTitleMargin: true; }' is not assignable to type 'IntrinsicAttributes & Omit<Pi...
                    ownerId={companyId}
                    noTitleMargin
                    readOnlyForm={readOnlyForm}
                />
            </Stack>
        </ResponsiveTwoColumns>
    );
};

export default ContractTab;
